import {matchPath} from 'react-router'
import {Route, Routes} from './routesMapping'

export const fullPath = <T extends Routes>(route: Route, routes: T): string => {
    for (const [routeType, routeGroup] of Object.entries(routes)) {
        for (const knownRoute of Object.values<Route>(routeGroup)) {
            if (knownRoute.path === route.path) {
                switch (routeType) {
                    case 'allOther':
                        return knownRoute.path
                    case 'withCustomerAndRk':
                        return `/readykit/:customerId/:rkId${knownRoute.path}`
                    case 'withCustomerOnly':
                        return `/customer/:customerId${knownRoute.path}`
                    default:
                        throw new Error(`Invariant - unknown route type ${routeType}`)
                }
            }
        }
    }

    throw new Error(`Unknown route ${route}`)
}

export const fullPathWithParams = <T extends Routes>(route: Route, routes: T, customerId = '', rkId = ''): string => {
    return fullPath(route, routes).replace(/:customerId|:rkId/g, match => {
        switch (match) {
            case ':customerId':
                return encodeURIComponent(customerId)
            case ':rkId':
                return encodeURIComponent(rkId)
            default:
                return match
        }
    })
}

export const fullPathWithTabId = <T extends Routes>(route: Route, routes: T, tabId: number): string => {
    return fullPath(route, routes).replace(/:tabId/g, () => {
        return encodeURIComponent(tabId)
    })
}

export const match = (path: string): {customerId?: string; rkId?: string} => {
    const rkMatch = matchPath('/readykit/:customerId/:rkId/*', path)
    const customerMatch = matchPath('/customer/:customerId/*', path)

    if (rkMatch) {
        return {
            rkId: rkMatch.params.rkId,
            customerId: rkMatch.params.customerId
        }
    }

    if (customerMatch) {
        return {customerId: customerMatch.params.customerId}
    }

    return {}
}
